export default "/images/double-quotes.svg?2cc951849e97b2395eac6dac594f9da0";